<template>
    <div class="section">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.$nextTick(function () {
                this.$store.dispatch('fetchBrands')
                this.$store.dispatch('fetchBrandLabels')
            })
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Auctions.vue